<template>
	<div>

		<div class="row section-top">
			<div class="col-md-12 pad0">
				<p class="section-lead">Lista de todos Sublocais de Trabalho cadastrados</p>
				<a href="/admin/sublocal/create" class="btn btn-outline-success float-right"><i class="fas fa-plus"></i>&nbsp;Novo</a>
				<div class="dropdown float-right">
					<button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<i class="fas fa-download"></i>
						Exportar
					</button>
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
						<a class="dropdown-item" href="#" @click="exportData('pdf')">PDF</a>
						<a class="dropdown-item" href="#" @click="exportData('csv')">Excel</a>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item" href="#" @click="$refs.gridfullexport.showModal('sublocal','sublocal')">Completo</a>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col">

				<!-- table -->
				<div class="card p-4">
					<vue-good-table v-if="workplacesItems.length"
						:columns="tableColumns"
						:rows="workplacesItems"
						:pagination-options="tablePagination"
						:search-options="{
							enabled: true,
							placeholder: 'Buscar..',
						}"
						styleClass="vgt-table"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<div>
									<button class="btn btn-sm btn-outline-secondary" v-if="userCan.edit" @click="editData(props.row)" title="Editar"><i class="far fa-edit"></i></button>
									<button class="btn btn-sm btn-outline-danger" v-if="userCan.delete" @click="deleteData(props.row.id, props.row.index)" title="Deletar"><i class="far fa-trash-alt"></i></button>
								</div>
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
						<template slot="pagination-bottom">
							<table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
						</template>
					</vue-good-table>
					<div v-else class="text-center p-3 text-muted">
						<h5>Nenhum sublocal de trabalho cadastrado!</h5>
					</div>
				</div>

				<div class="text-center p-4 text-muted" v-if="loading">
					<h5>Carregando...</h5>
					<p>Aguarde até que os dados sejam carregados...</p>
				</div>

			</div>

			<gridfullexport-component ref="gridfullexport"></gridfullexport-component>
			<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
		</div>
	</div>
</template>

<script>
	import ApiService from '../../apiservice.js';
	import ExportGrid from '../../exportgrid.js';
	import configData from "../../config.js";
	export default {
		mixins: [ApiService, configData, ExportGrid],
		props: ['permissions'],
		data() {
			return {
				companytypes: [],
				workplacesItems: [],
				fullPage: true,
				errors: [],
				loading: false,
				tablePagination: configData.tablePagination,
				tableColumns: [
					{
						label: 'ID',
						field: 'id',
					},{
						label: 'Nome do Sublocal',
						field: 'corporate_name',
					},{
						label: 'CNPJ',
						field: 'cnpj',
					},{
						label: 'Local de Trabalho',
						field: 'workplace.work_place.corporate_name',
					},{
						label: 'Tipo',
						field: 'company_types.name',
					},{
						label: 'Data e Hora',
						field: 'created_at',
						type: 'date',
						dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
						dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
					},{
						label: 'Ações',
						field: 'actions',
						sortable: false,
						width: '100px'
					}
				],
				tablePaginationOptions: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
				userCan: ''
			}
		},
		mounted() {
			this.userCan = JSON.parse(this.permissions);
			if(this.userCan.list){
				this.loadItems();
			}
		},
		methods: {
			pagination(page){
				this.tablePaginationOptions = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.loadItems();
			},
			loadItems() {
				let _this = this;
				_this.loading = true;
				var params = {
					page: _this.tablePaginationOptions.currentPage,
					perPage: _this.tablePaginationOptions.currentPerPage,
				};
				_this.workplacesItems = [];
				axios.post("/admin/sublocal/filter",{}, {params: params}).then((res) => {
					// _this.workplacesItems = _this.workplacesItems.concat(res.data);
					const { data, total, from, to } = res.data.data;
					_this.tablePaginationOptions.total = total;
					_this.tablePaginationOptions.from = from;
					_this.tablePaginationOptions.to = to;
					_this.workplacesItems = [...data];
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			exportData(type){
				var tempForm = $('#vgt-table');
				if(type == 'pdf'){
					this._exportPDF('Sublocal de Trabalho', [6], tempForm, ['ID','Nome do Sublocal','CNPJ','Local de Trabalho','Tipo','Data e Hora']);
				} else {
					this._exportExcel('Sublocal de Trabalho', [6], tempForm, ['ID','Nome do Sublocal','CNPJ','Local de Trabalho','Tipo','Data e Hora']);
				}
    	},
			deleteData(ID, index) {
				let _this = this;

				//show alert confirmation
				_this.$swal({
					title: "Excluir Sublocal",
					text: "Tem certeza que deseja excluir esse Sublocal de Trabalho?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Excluir",
					cancelButtonText: "Cancelar"
				}).then((alertConfirm) => {

					//validate isConfirmed
					if (alertConfirm.isConfirmed) {

						//remove
						axios.delete("/admin/sublocal/"+ID).then((res) => {

							//_this.workplaces.splice(index, 1);

							//call function in ApiService to validate success
							_this._api_validateSuccess(res,true);

						}).catch(err => {

							_this.loading = false;

							//call function in ApiService to validate error
							_this._api_validateError(err);

						});

					}//end validate isConfirmed

				});
				//end alert confirmation

			},
			editData(item){
				location.href="/admin/sublocal/"+item.id+"/edit";
			},
			resetForm(){

				this.workplace = {
					corporate_name: '',
					country: '',
					cnpj: '',
					address: '',
					number: '',
					complement: '',
					neighborhood: '',
					city: '',
					state: '',
					cep: '',
					company_type_id: '',
				};

			}
		}
	}
</script>
